/**
 在线运维--非直连订单列表
 */
import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import FormCore from "@/components/display/form/formCore";
import GridTable from "@/components/display/table/gridTableCore";
import RefreshGrid from "../../../utils/refreshGrid";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { useAuth ,triggerDownloadFiles} from "@/utils/utils";
import {
  prefixFile,
  exportFileInfoApi,
  getCityList,
  getUnDirectConnectOrderApi,
  getStubOrderInfoList,
} from "@/fetch/fetchApi";
import fetchHandlerFunc from "@/fetch/fetchHandler";

@connect((state) => state)
class UnDirectConnectOrder extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      formConfig: null,
      tableConfig: null,
      tableParam: {
        orderId: "", //订单号
        deviceId: "", //设备编号
        cityId: "", //地区
        date: "", //订单结束时间
      },
    };
  }
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.setState({
      tableConfig: this.initTableConfig(),
      formConfig: this.initFormConfig(),
    });
  }

  componentDidMount() {
    // this.fetchApi(this.state.tableParam);
    this.fetchApi({
      orderId: this.state.tableParam.orderId,
      deviceId: this.state.tableParam.deviceId,
      cityId: this.state.tableParam.cityId,
      startTime: moment(new Date()).subtract(90, "d").format("YYYY-MM-DD"),
      endTime: moment(new Date()).format("YYYY-MM-DD"),
    });
  }

  // 打开新tab页方法
  openTab = (param, e) => {
    console.log("openTab", param, e);
    this.props.onAdd(e, param);
  };

  //初始化表单
  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "请输入订单号",
          param: {
            name: "orderId",
            type: "string",
          },
          defaultValue: "",
          labelName: "订单号",
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入设备编号",
          param: {
            name: "deviceId",
            type: "string",
          },
          defaultValue: "",
          labelName: "设备编号",
          required: false,
        },
        // {
        //   type: "areaPicker",
        //   isPickArea: !0,
        //   placeholder: "请选择地区",
        //   pickOnSelect: true,
        //   param: {
        //     name: "cityId", // 与form表单绑定的参数名
        //     type: "array",
        //   },
        //   required: !1,
        //   labelName: "地区",
        //   className: "allshow",
        //   sourceApi: getCityList,
        //   mapKey: {
        //     label: "label",
        //     value: "value",
        //     children: "children",
        //   },
        //   defaultValue: [],
        //   allowClear: true,
        // },
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          param: {
            name: "cityId",
            type: "array",
          },  
          treeCheckable: true,
          treeCheckStrictly: false,
          showCheckedStrategy: "SHOW_PARENT",
          labelName: "地区",
          required: false,
          allowClear: true,
          sourceApi: getCityList,
          mapKey: {
            label: "title",
            value: "value",
            children: "children",
          },
          // onChange: this.handleAreaChange,
          // data: this.state.areaOptions,
          // defaultValue: [],
        },
        {
          type: "date",
          dateType: "rangeDate",
          placeholder: ["开始时间", "结束时间"],
          param: {
            name: "date",
            type: "array",
          },
          defaultValue: [moment().subtract(90, "d"), moment()],
          validator: {
            // 日期自定义校验规则
            vtype: "date", // 校验名称
            range: 0,
            max_val: 90,
            // notOverYear: true,
          }, // 自定义校验规则
          labelName: "订单结束时间",
          required: !1,
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("050901")
              ? {
                  btnType: "button",
                  text: "查询",
                  handler: (e, param) => {
                    console.log("handler:", param);
                    this.fetchApi(param);
                  },
                }
              : "",
            useAuth("050902")
              ? {
                  btnType: "button",
                  text: "导出",
                  handler: (e, param) => {
                    const newParam = {
                      ...param,
                      // token: window.sessionStorage.getItem("token"),
                      // companyId: window.sessionStorage.getItem("companyId"),
                      startTime: param.startTime ? param.startTime : param.date.split(",")[0],
                      endTime: param.endTime ? param.endTime : param.date.split(",")[1],
                    };
                    delete newParam.date;
                    delete newParam.page;
                    delete newParam.pagecount;
                    // let paramInfo = "",
                    //   params = "";
                    // Object.keys(newParam).forEach((key) => {
                    //   paramInfo = newParam[key] ? newParam[key] : "";
                    //   params += `${key}=${paramInfo}&`;
                    // });
                    this.exportData(newParam);
                  },
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !0, // 设置为false不触发加载grid
      defaultParams: {
        ...this.state.tableParam,
      },
      context: this,
      tableKey: "unDirectConnectOrderTable",
      tablePage: "非直连订单列表",
    };
    return formConfig;
  };
  //初始化表格
  initTableConfig = () => {
    const tableConfig = {
      tableKey: "unDirectConnectOrderTable",
      tableColumns: [
        {
          name: "订单号",
          key: "orderId",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "地区",
          key: "cityName",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "设备编号",
          key: "deviceId",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "充电状态",
          key: "statusStr",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "启动方式", // '运营类型'
          key: "startTypeStr",
          align: "left",
          width: 200,
          colType: "textCol",
          render: (value) => {
            // switch (value) {
            //   case 0:
            //     return "未知";
            //   case 1:
            //     return "APP或微信启动";
            //   case 2:
            //     return "计费卡启动";
            //   case 3:
            //     return "不计费卡启动";
            //   case 4:
            //     return "按钮或屏幕启动";
            //   case 5:
            //     return "擦枪启动";
            //   case 6:
            //     return "命令启动";
            //   case 7:
            //     return "桩定时启动";
            //   case 8:
            //     return "银联卡启动";
            //   case 9:
            //     return "互联互通启动";
            //   case 10:
            //     return "辅枪启动";
            //   case 11:
            //     return "在线VIN";
            //   case 12:
            //     return "离线VIN";
            //   case 13:
            //     return "受电弓";
            //   case 14:
            //     return "在线蓝牙MAC启动";
            //   case 15:
            //     return "OCPP小票机";
            //   case 16:
            //     return "预约即插即充";
            //   case 17:
            //     return "vin即插即充";
            //   case 18:
            //     return "在线蓝牙启动";
            //   case 19:
            //     return "蓝牙即插即充";
            //   case 20:
            //     return "支付宝车生活启动";
            //   default:
            //     return "未知";
            // }
            return <div>{value ? value : '--'}</div>
          },
        },
        {
          name: "开始充电时间",
          key: "startTime",
          colType: "tipCol",
          align: "left",
          width: 200,
        },
        {
          name: "结束充电时间",
          key: "endTime",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "充电时长", // 'iccid卡号',
          key: "timeChargeFormat",
          align: "left",
          colType: "textCol",
        },
        {
          name: "停止原因", // '地锁编号',
          key: "endReasonStr",
          align: "left",
          colType: "tipCol",
          render: (value, row) => {
            if (row.endReasonStr) {
              return row.endReasonStr;
            } else {
              return "--";
            }
          },
        },
        {
          name: "操作",
          key: "action",
          fix: "right",
          width: 320,
          colType: "action",
          actionMap: [
            useAuth("050903")
              ? {
                  type: "href",
                  actionName: "充电数据",
                  handler: (res) => {
                    console.log("handler res:", res, this, this.props);
                    this.openTab(
                      {
                        keyId: "chargeCourse",
                        orderId: res.orderId,
                        isUnDirect: true,
                      },
                      {
                        titleText: "充电数据",
                        key: "chargeCourse",
                      },
                    );
                    if (this.props.cancelModal) {
                      this.props.cancelModal();
                    }
                  },
                }
              : "",
          ],
        },
      ],
      tableParam: {
        pageCount: 10,
      },
      tableInfo: {
        hasRow: !1, // 是否显示checkbox
      },
      dataApi: getUnDirectConnectOrderApi,
      autoRefresh: !1, // 设置为true 直接加载grid数据
    };
    return tableConfig;
  };
  //刷新列表
  fetchApi = (param) => {
    console.log("fetchApi param:", param);
    const newParam = {
      ...param,
      cityId:param.cityId  ? param.cityId.join(",") : '',
      startTime: param.startTime ? param.startTime : param.date.split(",")[0],
      endTime: param.endTime ? param.endTime : param.date.split(",")[1],
    };
    if (newParam.date) {
      delete newParam.date;
    }
    console.log("fetchApi newParam:", newParam);

    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(newParam);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "unDirectConnectOrderTable", newParam);
    }
  };

  //导出
  exportData = (paramString) => {
    console.log("paramString:", paramString);
    triggerDownloadFiles('/mtsV2/out/order/export',{
      ...paramString
    },'非直连订单列表','xlsx','post')
    // fetch(`${prefixFile}/mtsV2/out/order/export`, {
    //   body: JSON.stringify(paramString),
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: window.sessionStorage.getItem("token"),
    //   },
    // })
    //   .then((res) => res.blob())
    //   .then((res) => {
    //     console.log("exportFileInfo res:", res);
    //     const blobUrl = window.URL.createObjectURL(res);
    //     console.log("exportFileInfo blobUrl:", blobUrl);
    //     const ele = document.createElement("a");
    //     // ele.download = '';
    //     ele.style.display = "none";
    //     ele.href = blobUrl;
    //     ele.target = "_blank"; // 针对 ie模式 的浏览器
    //     // 触发点击
    //     document.body.appendChild(ele);
    //     ele.click();
    //     // 然后移除
    //     document.body.removeChild(ele);
    //     window.URL.revokeObjectURL(blobUrl);
    //   });
  };
  render() {
    return (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <GridTable config={this.state.tableConfig} />
        </div>
      </div>
    );
  }
}

export default injectIntl(UnDirectConnectOrder);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/UnDirectConnectOrder.js